export const projects = [
  {
    id: '4',
    name: 'Escuela Fácil',
    thumbnail: '/images/escuela-facil.PNG',
    screenshots: [
      '/images/screenshots/escuela-facil/1.PNG',
      '/images/screenshots/escuela-facil/2.PNG',
      '/images/screenshots/escuela-facil/3.PNG',
      '/images/screenshots/escuela-facil/4.PNG',
      '/images/screenshots/escuela-facil/5.PNG',
      '/images/screenshots/escuela-facil/6.PNG',
      '/images/screenshots/escuela-facil/7.PNG',
      '/images/screenshots/escuela-facil/8.PNG',
    ],
    description: {
      es: 'App de organización escolar en producción, usada por varias escuelas en México. Participé en el desarrollo del módulo de transporte de punta a punta —modelo de datos, lógica de negocio en Nest.js, pantallas en React Native y páginas del backoffice— y desde hace varios meses soy el desarrollador principal: implemento features y mejoras, mantengo la aplicación en producción y participo del deployment.',
      en: 'School-management app in production, used by several schools in Mexico. I helped build the transportation module end to end —data model, Nest.js business logic, React Native screens, and backoffice pages— and for the past several months I have been the lead developer: I ship new features and improvements, maintain the production app, and take part in deployment.',
    },
    features: {
      es: [
        'Módulo de transporte: rutas, transportes, personas y domicilios de confianza, solicitudes y aprobación de permisos de salida e invitaciones, cron diario con lógica automática de procesamiento de permisos y asignación de rutas.',
        'Desarrollo end-to-end: entidades, migraciones, controllers, services, repositories, DTOs, validaciones y roles con distintos permisos.',
        'Pantallas nuevas en React Native con formularios y conexión a la API.',
        'Páginas del backoffice en Next.js conectadas a la API.',
        'Soporte en producción del módulo nuevo y de la aplicación en su totalidad, con participación en el deployment.',
      ],
      en: [
        'Transportation module: routes, vehicles, trusted contacts, trusted addresses, requests and approval of exit permissions and invitations, daily cron with automatic logic for processing permissions and assigning routes.',
        'End-to-end development: entities, migrations, controllers, services, repositories, DTOs, validations, and roles with different permissions.',
        'New React Native screens with forms and API integration.',
        'Backoffice pages in Next.js connected to the API.',
        'Production support for the new module and the application as a whole, including participation in deployment.',
      ],
    },
    technologies: [
      'React Native',
      'TypeScript',
      'Nest.js',
      'Next.js',
      'React',
      'PostgreSQL',
    ],
    googlePlay:
      'https://play.google.com/store/apps/details?id=app.escuelafacil&hl=es_AR',
    appStore:
      'https://apps.apple.com/ar/app/escuela-f%C3%A1cil-comunica-bien/id6747779893',
    important: true,
    mobile: true,
  },
  {
    id: '5',
    name: 'Soy Más',
    thumbnail: '/images/soy-mas.PNG',
    screenshots: [
      '/images/screenshots/soy-mas/1.PNG',
      '/images/screenshots/soy-mas/2.PNG',
      '/images/screenshots/soy-mas/3.PNG',
      '/images/screenshots/soy-mas/4.PNG',
      '/images/screenshots/soy-mas/5.PNG',
      '/images/screenshots/soy-mas/6.PNG',
      '/images/screenshots/soy-mas/7.PNG',
      '/images/screenshots/soy-mas/8.PNG',
    ],
    description: {
      es: 'App móvil que desarrollé desde cero hasta producción como único desarrollador mobile. Tomé decisiones de arquitectura, construí componentes reutilizables y pantallas, e implementé la lógica y la comunicación con una API preexistente y con Supabase para autenticación.',
      en: 'Mobile app I built from scratch to production as the only mobile developer. I owned architecture decisions, built the reusable UI and screens, and implemented the logic and communication with an existing API and with Supabase for authentication.',
    },
    features: {
      es: [
        'Desarrollo completo de la app móvil con React Native, Expo y TypeScript.',
        'Arquitectura, componentes reutilizables y pantallas desde cero.',
        'Integración con una API preexistente y autenticación con Supabase.',
        'Lanzamiento a producción en Google Play y App Store.',
      ],
      en: [
        'Full mobile app development with React Native, Expo, and TypeScript.',
        'Architecture, reusable components, and screens built from scratch.',
        'Integration with an existing API and authentication with Supabase.',
        'Production launch on Google Play and the App Store.',
      ],
    },
    technologies: ['React Native', 'TypeScript', 'Expo'],
    googlePlay:
      'https://play.google.com/store/apps/details?id=la.soymas.app&hl=es_AR',
    appStore: 'https://apps.apple.com/us/app/soy-mas/id6774607557',
    important: true,
    mobile: true,
  },
  {
    id: '1',
    name: 'RealMeet',
    thumbnail: '/images/realmeet.PNG',
    screenshots: [
      '/images/screenshots/realmeet/1.PNG',
      '/images/screenshots/realmeet/2.PNG',
      '/images/screenshots/realmeet/3.PNG',
      '/images/screenshots/realmeet/4.PNG',
      '/images/screenshots/realmeet/5.PNG',
      '/images/screenshots/realmeet/6.PNG',
      '/images/screenshots/realmeet/7.PNG',
      '/images/screenshots/realmeet/8.PNG',
      '/images/screenshots/realmeet/9.PNG',
      '/images/screenshots/realmeet/10.PNG',
    ],
    description: {
      es: 'App para conectar personas a través de actividades y experiencias sociales. Participé del desarrollo completo hasta producción y hoy doy mantenimiento, corrijo errores, implemento features nuevas y participo del deployment. Actualmente está disponible en su versión web con usuarios activos.',
      en: 'App to connect people through social activities and experiences. I took part in the full development through production and today I maintain it, fix bugs, ship new features, and take part in deployment. It is currently available in its web version with active users.',
    },
    features: {
      es: [
        'Desarrollo full-stack con React Native, React, Node.js, Express y PostgreSQL.',
        'Integraciones con autenticación de terceros, pagos y suscripciones con Mercado Pago, mapas y geolocalización.',
        'Notificaciones push y por email.',
        'Panel de administración en React y TypeScript.',
        'Mantenimiento en producción: bugs, mejoras, features nuevas y deployment.',
        'Disponible en web con usuarios reales activos.',
      ],
      en: [
        'Full-stack development with React Native, React, Node.js, Express, and PostgreSQL.',
        'Integrations with third-party authentication, payments and subscriptions with Mercado Pago, maps, and geolocation.',
        'Push and email notifications.',
        'Admin panel in React and TypeScript.',
        'Production maintenance: bugs, improvements, new features, and deployment.',
        'Available on the web with active real users.',
      ],
    },
    technologies: [
      'React Native',
      'TypeScript',
      'React',
      'Node.js',
      'Express',
      'PostgreSQL',
    ],
    deploy: 'https://app.realmeet.net',
    important: true,
    mobile: true,
  },
  {
    id: '2',
    name: 'Hub+',
    thumbnail: '/images/hubplus.PNG',
    screenshots: [
      '/images/screenshots/hubplus/1.PNG',
      '/images/screenshots/hubplus/2.PNG',
      '/images/screenshots/hubplus/3.PNG',
      '/images/screenshots/hubplus/4.PNG',
      '/images/screenshots/hubplus/5.PNG',
      '/images/screenshots/hubplus/6.PNG',
      '/images/screenshots/hubplus/7.PNG',
    ],
    description: {
      es: 'App de reservas para salones de belleza y servicios relacionados que desarrollé desde cero hasta su lanzamiento en App Store y Google Play. El producto se encuentra actualmente descontinuado; se documenta el trabajo entregado.',
      en: 'Booking app for beauty salons and related services that I built from scratch through its launch on the App Store and Google Play. The product is currently discontinued; this page documents the work that was delivered.',
    },
    features: {
      es: [
        'Desarrollo completo de aplicación móvil, panel de administración y backend con React Native, React, Node.js, Express y PostgreSQL.',
        'Reservas online, búsqueda por proximidad, disponibilidad en tiempo real y gestión de turnos.',
        'Notificaciones push y por email, historial de reservas e integración con Mercado Pago.',
        'Lanzada a producción en las tiendas con usuarios activos; el producto se encuentra actualmente descontinuado.',
      ],
      en: [
        'Full mobile, admin panel, and backend development with React Native, React, Node.js, Express, and PostgreSQL.',
        'Online bookings, search by proximity, real-time availability, and appointment management.',
        'Push and email notifications, booking history, and Mercado Pago integration.',
        'Launched to production on the stores with active users; the product is currently discontinued.',
      ],
    },
    technologies: [
      'React Native',
      'TypeScript',
      'React',
      'Node.js',
      'Express',
      'PostgreSQL',
    ],
    important: false,
    mobile: true,
  },
  {
    id: '3',
    name: 'Stetsiuk Weightlifting',
    thumbnail: '/images/stetsiuk-fitness.PNG',
    screenshots: [
      '/images/screenshots/fitness/1.PNG',
      '/images/screenshots/fitness/2.PNG',
      '/images/screenshots/fitness/3.PNG',
      '/images/screenshots/fitness/4.PNG',
      '/images/screenshots/fitness/5.PNG',
      '/images/screenshots/fitness/6.PNG',
      '/images/screenshots/fitness/7.PNG',
      '/images/screenshots/fitness/8.PNG',
      '/images/screenshots/fitness/9.PNG',
      '/images/screenshots/fitness/10.PNG',
      '/images/screenshots/fitness/11.PNG',
      '/images/screenshots/fitness/12.PNG',
      '/images/screenshots/fitness/13.PNG',
      '/images/screenshots/fitness/14.PNG',
      '/images/screenshots/fitness/15.PNG',
    ],
    description: {
      es: 'App de entrenamiento de weightlifting en producción, con más de 1000 usuarios activos. Participé del desarrollo completo y hoy doy mantenimiento, corrijo errores, implemento features nuevas y participo del deployment. Disponible en App Store y Google Play.',
      en: 'Weightlifting training app in production, with more than 1,000 active users. I took part in the full development and today I maintain it, fix bugs, ship new features, and take part in deployment. Available on the App Store and Google Play.',
    },
    features: {
      es: [
        'Desarrollo full-stack con React Native, React, Node.js, Express, PostgreSQL y AWS.',
        'Rutinas personalizadas, librería de videos y evaluaciones de progreso.',
        'Panel de administración y back-end con nuevas features e integraciones.',
        'Plan premium con suscripciones mensuales, semestrales y anuales.',
        'En producción en App Store y Google Play, con más de 1000 usuarios activos.',
      ],
      en: [
        'Full-stack development with React Native, React, Node.js, Express, PostgreSQL, and AWS.',
        'Personalized routines, video library, and progress assessments.',
        'Admin panel and back-end with new features and integrations.',
        'Premium plan with monthly, six-month, and annual subscriptions.',
        'In production on the App Store and Google Play, with more than 1,000 active users.',
      ],
    },
    technologies: [
      'React Native',
      'TypeScript',
      'React',
      'Node.js',
      'Express',
      'PostgreSQL',
      'AWS',
    ],
    googlePlay:
      'https://play.google.com/store/apps/details?id=com.stetsiukweightlifting',
    appStore:
      'https://apps.apple.com/ye/app/stetsiuk-weightlifting/id6766249285',
    important: true,
    mobile: true,
  },
];
